export default __webpack_public_path__ + "img/dhwMSspz.8dbc30bc.svg";